import React, {
  createContext,
  useContext,
  useMemo,
} from 'react';
import {
  extraResourceGroupOptions,
  BookExtraResourceType,
  BookExtraResourceStatus,
} from '../../../ui/src/common/book/BookHelpers';

interface BookModel {
  book: any;
  setBook: any;
  extraResourceGroups: any;
}

const BookContext = createContext<BookModel>(null);

export const useBookContext = () => {
  return useContext(BookContext);
};
const groupBy = (xs) => {
  let result = xs.reduce((groups, extraResource) => {
    if (!Array.isArray(groups)) {
      groups = [];
    }
    let tmp = groups?.find((s) => s.index === extraResource.group);
    if (!tmp) {
      tmp = {
        index: extraResource.group,
        key: extraResourceGroupOptions.find(
          (ext) => ext.value === extraResource.group,
        ).label,
        icon: extraResourceGroupOptions.find(
          (ext) => ext.value === extraResource.group,
        ).icon,
        extraResources: [extraResource],
      };
      groups.push(tmp);
    } else {
      tmp?.extraResources?.push(extraResource);
    }
    return groups;
  }, []);
  return result;
};
export const BookProvider: React.FC<{ book: any; setBook: any, children: any }> = ({
  children,
  book,
  setBook,
}) => {

  const extraResourceGroups = useMemo(() => {
    let _extraResources = book.extraResources.filter(
      (e) =>
        !!e.name &&
        !!e.link &&
        e.status === BookExtraResourceStatus.Show &&
        (e.type === BookExtraResourceType.All),
    );
    _extraResources = groupBy(_extraResources);
    return _extraResources || [];
  }, [book]);

  const value = {
    book,
    setBook,
    extraResourceGroups,
  };

  return (
    <BookContext.Provider value={value}>
      {children}
    </BookContext.Provider>
  );
};
